import { render, staticRenderFns } from "./guanqiaData.vue?vue&type=template&id=97f04810&"
import script from "./guanqiaData.vue?vue&type=script&lang=js&"
export * from "./guanqiaData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97f04810')) {
      api.createRecord('97f04810', component.options)
    } else {
      api.reload('97f04810', component.options)
    }
    module.hot.accept("./guanqiaData.vue?vue&type=template&id=97f04810&", function () {
      api.rerender('97f04810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/guanqia/guanqiaData.vue"
export default component.exports